import { useTranslation } from "react-i18next"

import { AlertCircle } from "@/components/icons"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

type AdminDashboardErrorProps = {
  error: Error
  onRetry: () => void
}

export function AdminDashboardError({ error, onRetry }: AdminDashboardErrorProps) {
  const { t } = useTranslation()
  const isDevelopment = import.meta.env.DEV

  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <Card className="max-w-lg rounded-lg shadow-sm">
        <CardHeader>
          <div className="flex items-center gap-3">
            <div className="bg-destructive/10 rounded-full p-2">
              <AlertCircle className="text-destructive h-6 w-6" />
            </div>
            <CardTitle className="text-destructive">{t("adminDashboard.errors.title")}</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-muted-foreground text-sm">{t("adminDashboard.errors.description")}</p>

          {isDevelopment && error.message && (
            <div className="bg-muted rounded-lg p-3">
              <p className="text-muted-foreground font-mono text-xs">
                <span className="font-semibold">Fel:</span> {error.message}
              </p>
            </div>
          )}

          <div className="flex gap-3">
            <Button className="flex-1" onClick={onRetry}>
              {t("adminDashboard.errors.retry")}
            </Button>
            <Button className="flex-1" variant="outline" onClick={() => window.location.reload()}>
              {t("adminDashboard.errors.reload")}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
